import { API_STATUS } from 'core-lib/constants/network';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchServiceableCities } from '../services/fetchServiceableCities';
import { updateServiceableList } from '../store';

export const useServiceability = () => {
  const { list, apiStatus } = useSelector(
    (state:any) => state?.testDrive?.serviceableData
  );

  const dispatch = useDispatch();

  const getData = async () => {
    dispatch(
      updateServiceableList({
        list: [],
        apiStatus: API_STATUS.in_progress,
        oemPayload: null,
      })
    );
    const response = await fetchServiceableCities();
    if (response) {
      dispatch(
        updateServiceableList({
          list: response.list,
          apiStatus: API_STATUS.success,
          oemPayload: response?.oemPayload,
        })
      );
    } else {
      dispatch(
        updateServiceableList({
          list: [],
          apiStatus: API_STATUS.failure,
          oemPayload: null,
        })
      );
    }
  };

  useEffect(() => {
    if ([API_STATUS.default].includes(apiStatus)) {
      getData();
    }
  }, [apiStatus]);
  return {
    list,
    serviceableStatus: apiStatus,
  };
};
